export const ERROR_MESSAGES: Record<number | string, string> = {
  [403]: $localize`You do not have permission to access the requested resource.`,
  [500]: $localize`Server error. If the issue persists please contact the system administrator.`,
  ['no-internet']: $localize`No internet connection`,
};

export function getUserFriendlyErrorMessageForHttpErrors(
  errorStatusCode: number
): string | undefined {
  return ERROR_MESSAGES[errorStatusCode];
}

export function getUserFriendlyErrorMessageForNoInternet() {
  return ERROR_MESSAGES['no-internet'];
}
